import React from "react";

const AUTO_SENT = {
  title: "Enviado automáticamente a Mesa de Control: 3 días sin movimientos",
  style: { background: "#fff1d6", color: "#a86500", border: "1px solid #f59e0b" },
};

const chipStyle = {
  display: "inline-block",
  fontSize: "10px",
  fontWeight: 700,
  lineHeight: 1.4,
  padding: "0 6px",
  borderRadius: "999px",
  marginLeft: "6px",
  verticalAlign: "middle",
};

/**
 * Folio del caso con sus etiquetas: el folio se resalta cuando el caso esta en Mesa de Control por
 * el envio automatico de 3 dias sin movimientos, y lleva una insignia si se abrio con captura
 * asistida por IA o quedo con documentacion incompleta.
 */
const CaseTicket = ({ caseRecord }) => {
  const autoSent = caseRecord.autoSentToControlDesk === true;
  return (
    <>
      <span
        title={autoSent ? AUTO_SENT.title : undefined}
        style={autoSent ? { ...AUTO_SENT.style, borderRadius: "4px", padding: "0 6px", fontWeight: 600 } : undefined}
      >
        {autoSent && <i className="fa fa-clock mr-1" aria-hidden="true" />}
        {caseRecord.caseTicket}
      </span>
      {caseRecord.automaticCreation === true && (
        <span title="Captura asistida por IA" style={{ ...chipStyle, background: "#e3f0ff", color: "#1e6fd9" }}>
          IA
        </span>
      )}
      {caseRecord.documentationIncomplete === true && (
        <span title="Documentación incompleta" style={{ ...chipStyle, background: "#fff1d6", color: "#a86500" }}>
          Docs
        </span>
      )}
    </>
  );
};

export default CaseTicket;
